/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Close_SuccessInputs */

const en_settings_tickets_close_success = /** @type {(inputs: Settings_Tickets_Close_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket closed`)
};

/**
* | output |
* | --- |
* | "Ticket closed" |
*
* @param {Settings_Tickets_Close_SuccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_close_success = /** @type {((inputs?: Settings_Tickets_Close_SuccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Close_SuccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_close_success(inputs)
});
export { settings_tickets_close_success as "settings.tickets.close_success" }